import { GameConfig } from "../config/GameConfig";
import { GameNavigator } from "../core/Navigation";
import { GameStore } from "../core/GameStore";
import { UIFactory } from "../ui/UIFactory";

export abstract class BaseScreen extends Laya.Box {
    protected readonly nav: GameNavigator;
    protected readonly store = GameStore.instance;
    protected coinPill: Laya.Box;
    protected energyPill: Laya.Box;

    constructor(nav: GameNavigator) {
        super();
        this.nav = nav;
        this.width = GameConfig.DESIGN_WIDTH;
        this.height = Math.max(GameConfig.DESIGN_HEIGHT, Laya.stage.height || GameConfig.DESIGN_HEIGHT);
        this.name = this.constructor.name;
        this.store.on(GameStore.CHANGED, this, this.refreshStats);
    }

    protected buildTopStats(dark = true): void {
        this.coinPill = UIFactory.statPill("¥", String(this.store.state.coins), 180);
        this.coinPill.pos(34, 35);
        this.addChild(this.coinPill);
        this.energyPill = UIFactory.statPill("⚡", `${this.store.state.energy}/${GameConfig.MAX_ENERGY}`, 184);
        this.energyPill.pos(532, 35);
        this.addChild(this.energyPill);
        if (!dark) {
            this.coinPill.alpha = 0.95;
            this.energyPill.alpha = 0.95;
        }
    }

    protected refreshStats(): void {
        if (this.coinPill) UIFactory.setPillValue(this.coinPill, String(this.store.state.coins));
        if (this.energyPill) UIFactory.setPillValue(this.energyPill, `${this.store.state.energy}/${GameConfig.MAX_ENERGY}`);
    }

    destroy(destroyChild = true): void {
        this.store.off(GameStore.CHANGED, this, this.refreshStats);
        super.destroy(destroyChild);
    }
}
